import {IIT_ECP} from '../actions/types';

const initialState = {
   
}

export default function(state = initialState, action) {
    switch (action.type) {
        case IIT_ECP:
        return {
          ...state,
          eusign: action.payload,
        };
        default:
        return state;
    }
}